import { render } from "./BGWrapper.vue?vue&type=template&id=b6a4a928"
import script from "./BGWrapper.vue?vue&type=script&lang=js"
export * from "./BGWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__